import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const SCORE_MAP = {
  1: {
    title: 'signup.tooltip.password.strength.weak',
    color: '#F25F5C',
  },
  2: {
    title: 'signup.tooltip.password.strength.fair',
    color: '#FFE066',
  },
  3: {
    title: 'signup.tooltip.password.strength.good',
    color: '#247BA0',
  },
  4: {
    title: 'signup.tooltip.password.strength.strong',
    color: '#70C1B3',
  },
}

const Container = styled.div`
  width: 100%;
`

const Progress = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 2px;
  background-color: #f0f0f0;

  & > div {
    width: ${({ value }) => `${(value / 4) * 100}%`};
    background-color: ${({ backgroundColor }) => backgroundColor};
  }
`

const ProgressBar = styled.div`
  position: absolute;
  /* width: 100%; */
  height: 100%;
  border-radius: 2px;
`

const Text = styled.div`
  font-size: 0.667rem;
  margin-top: 8px;
`

const PasswordStrengthMeter = ({ score }) => {
  const intl = useIntl()

  const scoreObj = useMemo(() => {
    const s = Math.min(Math.max(1, score), 4)
    return {
      value: s,
      ...SCORE_MAP[s],
    }
  }, [score])

  return (
    <Container>
      <Progress value={scoreObj.value} backgroundColor={scoreObj.color}>
        <ProgressBar />
      </Progress>
      <Text>{intl.formatMessage({ id: scoreObj.title })}</Text>
    </Container>
  )
}

export default PasswordStrengthMeter
